(function($) {
	'use strict';

	$.widget('msv.sticky', {

		options: {
			el: {}
		},

		_create: function() {
			var self = this;
			/**/
			this.options.el.aside = $(".aside");
			this.options.el.shield = $(".aside .shield");
			this.options.el.asideBody = $(".aside__body");
			this.options.el.asideTrigger = $(".aside__trigger");
			/**/
			this._events();
			this._calculate();
			$(window).on('scroll', function() {
				self._calculate();
			});
			$(window).on('resize', function() {
				self._calculate();
			});
		},

		_events: function() {
			var self = this;
			this.options.el.shield.click(function() {
				self._mobileClose();
			});
			this.options.el.asideTrigger.click(function() {
				if ($(this).hasClass("opened")) {
					self._mobileClose();
				}
				else {
					self._mobileOpen();
				}
			});
			$.subscribe("OPEN_MOBILE_MENU", function() {
				self._mobileClose();
				self._mobileHide();
			});
			$.subscribe("CLOSE_MOBILE_MENU", function() {
				self._mobileShow();
			});
			$.subscribe("OPEN_SEARCH", function() {
				self._mobileClose();
			});
		},

		_calculate: function() {
			var $floatingPanel = $("aside.aside");
			var $floatingPanelBody = $floatingPanel.find(".aside__body");
			var $pageHeader = $(".hero");
			var $stickyContainer = $(".sticky-container");
			var $stickyContent = $stickyContainer.closest(".row");
			this.options.asideHeight = $floatingPanel.height();
			this.options.asideBodyHeight = $floatingPanelBody.height();
			if (window.innerWidth >= 960) {
				var windowTop = $(window).scrollTop();
				var stickyContentTop = $stickyContent.offset().top;
				var stickyPoint = stickyContentTop + $stickyContent.height() - this.options.asideHeight - 350; //for padding purposes
				// console.log('aside:' + windowTop, stickyPoint, $pageHeader.height() + 100);


				if (windowTop <= $pageHeader.height() - 100) {
					$floatingPanel.css({
						position: "static",
						top: "auto",
						right: "auto",
						bottom: "auto",
						left: "auto",
						width: "auto",
						marginTop: -230
					});
				}
				else {
					if (windowTop <= stickyPoint) {
						$floatingPanel.css({
							position: "fixed",
							top: 130,
							right: "auto",
							bottom: "auto",
							left: "auto",
							width: $stickyContainer.width(),
							marginTop: 0
						});
					}
					else {
						if (windowTop >= 2000 && windowTop <= 4400) {
							$floatingPanel.css({
								position: "fixed",
								top: 130,
								right: "auto",
								bottom: "auto",
								left: "auto",
								width: $stickyContainer.width(),
								marginTop: 0
							});
						}
						else {
							$floatingPanel.css({
								position: "absolute",
								top: stickyPoint - this.options.asideHeight - 250,
								right: "auto",
								bottom: "auto",
								left: "auto",
								width: $stickyContainer.width(),
								marginTop: 0
							});
						}
					}
				}
			}
			else {
				$(".aside__trigger").removeClass("opened");
				$(".aside").removeClass("hasShield");
				$floatingPanel.css({
					position: "fixed",
					top: "auto",
					right: "auto",
					bottom: "0",
					left: "0",
					width: "100%"
				});
				$floatingPanelBody.css({
					bottom: -this.options.asideBodyHeight - this.options.asideHeight
				});
			}
		},

		_mobileOpen: function() {
			this.options.el.asideBody.animate({
				bottom: this.options.asideHeight
			}, 300);
			this.options.el.asideTrigger.addClass("opened");
			this.options.el.aside.addClass("hasShield");
		},

		_mobileClose: function() {
			this.options.el.asideBody.animate({
				bottom: -this.options.asideBodyHeight - this.options.asideHeight
			}, 300);
			this.options.el.asideTrigger.removeClass("opened");
			this.options.el.aside.removeClass("hasShield");
		},

		_mobileHide: function() {
			this.options.el.aside.hide();
		},

		_mobileShow: function() {
			this.options.el.aside.show();
		}

	});

})(jQuery);